import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRows } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const FUNDING_DIRECTIONS_NAMES = {
  CURRENCY: 'currency',
  VARIANTS: 'variants',
  TABLE: 'table',
  TOTAL: 'total',
  R_AND_D_SUB_ROWS: 'rAndDSubRows',
  MARKETING_AND_SALES_SUB_ROWS: 'marketingAndSalesSubRows',
  WORKING_CAPITAL_SUB_ROW: 'workingCapitalSubRow',
  CONSTRUCTION_SUB_ROW: 'constructionSubRow',
  EQUIPMENT_PURCHASE_SUB_ROW: 'equipmentPurchaseSubRow',
  OTHER_SUB_ROW: 'otherSubRow',
} as const;

export const NAME_FIELD_NAME = 'name';
export const MAX_SUB_ROWS = 5;

export const SUB_ROWS_NAMES_ARRAY = [
  FUNDING_DIRECTIONS_NAMES.R_AND_D_SUB_ROWS,
  FUNDING_DIRECTIONS_NAMES.MARKETING_AND_SALES_SUB_ROWS,
  FUNDING_DIRECTIONS_NAMES.WORKING_CAPITAL_SUB_ROW,
  FUNDING_DIRECTIONS_NAMES.CONSTRUCTION_SUB_ROW,
  FUNDING_DIRECTIONS_NAMES.EQUIPMENT_PURCHASE_SUB_ROW,
  FUNDING_DIRECTIONS_NAMES.OTHER_SUB_ROW,
];
const fundingDirectionsVariants = [
  'R&D',
  'Marketing and Sales',
  'Working Capital',
  'Construction',
  'Equipment Purchase',
  'Other',
];

export interface ISubRowType extends IPeriodsTableRow {
  name: string;
}

export const subRowInitialValues: ISubRowType = {
  ...(structuredClone(initialPeriodsTableRow)),
  name: '',
};

export interface IFundingDirectionsFormValuesType {
  [FUNDING_DIRECTIONS_NAMES.VARIANTS]: string[];
  [FUNDING_DIRECTIONS_NAMES.TABLE]: IPeriodsTableRow[];
  [FUNDING_DIRECTIONS_NAMES.TOTAL]: IPeriodsTableRow;
  [FUNDING_DIRECTIONS_NAMES.MARKETING_AND_SALES_SUB_ROWS]: ISubRowType[];
  [FUNDING_DIRECTIONS_NAMES.WORKING_CAPITAL_SUB_ROW]: ISubRowType[];
  [FUNDING_DIRECTIONS_NAMES.CONSTRUCTION_SUB_ROW]: ISubRowType[];
  [FUNDING_DIRECTIONS_NAMES.EQUIPMENT_PURCHASE_SUB_ROW]: ISubRowType[];
  [FUNDING_DIRECTIONS_NAMES.OTHER_SUB_ROW]: ISubRowType[];
  [FUNDING_DIRECTIONS_NAMES.R_AND_D_SUB_ROWS]: ISubRowType[];
}

export interface IFundingDirectionsErrorCallback {
  subRowValues: IPeriodsTableRows[];
  fundingIndex: number;
  errorMessage: string;
}

export const fundingDirectionsInitialValues = {
  [FUNDING_DIRECTIONS_NAMES.VARIANTS]: fundingDirectionsVariants,
  [FUNDING_DIRECTIONS_NAMES.TABLE]: getFormTableInitialValues2(
    fundingDirectionsVariants.length,
    initialPeriodsTableRow,
  ),
  [FUNDING_DIRECTIONS_NAMES.MARKETING_AND_SALES_SUB_ROWS]: getFormTableInitialValues2(1, subRowInitialValues),
  [FUNDING_DIRECTIONS_NAMES.WORKING_CAPITAL_SUB_ROW]: getFormTableInitialValues2(1, subRowInitialValues),
  [FUNDING_DIRECTIONS_NAMES.CONSTRUCTION_SUB_ROW]: getFormTableInitialValues2(1, subRowInitialValues),
  [FUNDING_DIRECTIONS_NAMES.EQUIPMENT_PURCHASE_SUB_ROW]: getFormTableInitialValues2(1, subRowInitialValues),
  [FUNDING_DIRECTIONS_NAMES.OTHER_SUB_ROW]: getFormTableInitialValues2(1, subRowInitialValues),
  [FUNDING_DIRECTIONS_NAMES.R_AND_D_SUB_ROWS]: getFormTableInitialValues2(1, subRowInitialValues),
  [FUNDING_DIRECTIONS_NAMES.TOTAL]: initialPeriodsTableRow,
};

export const errorMessages = {
  rAndD: 'financialPlan.cashFlowElements.fundingDirections.errors.rAndD',
  marketingAndSales: 'financialPlan.cashFlowElements.fundingDirections.errors.marketingAndSales',
  workingCapital: 'financialPlan.cashFlowElements.fundingDirections.errors.workingCapital',
  construction: 'financialPlan.cashFlowElements.fundingDirections.errors.construction',
  equipmentPurchase: 'financialPlan.cashFlowElements.fundingDirections.errors.equipmentPurchase',
  other: 'financialPlan.cashFlowElements.fundingDirections.errors.other',
}
